import { render, staticRenderFns } from "./DownloadBase.vue?vue&type=template&id=02bf0815"
import script from "./DownloadBase.vue?vue&type=script&lang=js"
export * from "./DownloadBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports